import api from '../api';

export async function getConpanyService(companyId) {
  try {
    const { data } = await api.get(`empresa/encontrar/${companyId}`);
    return data;
  } catch (error) {
    return null;
  }
}
